<template>
  <layout-main-inner
    v-loading="loading"
    title="鉴定证书管理">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增证书
      </el-button>
    </div>
    <layout-card-wrap>
      <el-form
        label-width="85px"
        @submit.native.prevent>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="出证日期:">
              <el-date-picker
                v-model="config.time"
                unlink-panels=""
                placement="bottom-start"
                style="width: 100%;"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="证书模板:">
              <cert-template-select v-model="config.certTemplateId" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="证书编号:">
              <el-input
                v-model="config.certNo"
                clearable
                placeholder="请输入证书编号"
                @clear="handleCurrentChange(1)">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                style="margin-right:10px;"
                type="primary"
                @click="handleCurrentChange(1)">查询</el-button>
              <!-- <el-button
                type="primary"
                style="margin-right:10px;"
                :disabled="multipleSelection.length === 0"
                @click="downloadidentificationcerts">下载（{{ multipleSelection.length }}）</el-button> -->
              <download-button
                :taskType="5"
                :createDownloadFile="createDownloadFile"
                :validate="onValidate" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="multipleTable"
        border
        row-key="identificationCertId"
        :data="list"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          label="证书编号"
          min-width="120"
          prop="certNo">
        </el-table-column>
        <el-table-column
          label="证书文件/链接"
          min-width="380">
          <template slot-scope="{ row }">
            <el-image
              v-if="!row.isH5"
              style="width:48px"
              :src="row.certFile"
              :preview-src-list="[row.certFile]"></el-image>
            <el-link
              v-else
              style="font-size:12px"
              type="primary"
              :underline="false"
              :href="row.certFile"
              target="_blank">{{ row.certFile }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="证书模板"
          min-width="100"
          prop="certTemplateName">
        </el-table-column>
        <el-table-column
          label="出证日期"
          width="90">
          <template slot-scope="{ row }">
            <span>{{ row.certIssuanceTime | dateformat('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="90">
          <template slot-scope="{ row }">
            <template v-if="!row.isH5">
              <el-button
                type="text"
                @click="updateitem(row)">编辑</el-button>
              <el-button
                type="text"
                @click="deleteitem(row)">删除</el-button>
            </template>
            <template v-else>
              <el-button
                type="text"
                @click="downloadtemplate(row)">下载</el-button>
              <el-button
                type="text"
                @click="updateitemtime(row)">编辑</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="getlist" />
    </layout-card-wrap>
    <edit-cert-modal
      ref="cert"
      :callback="() => { getlist() }"
    />
    <edit-cert-time-modal
      ref="time"
      @fetch="getlist" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditCertModal from './edit-cert-modal.vue'
import Cert from '@/service/cert'
import Download from '@/service/download'
import { downloadBlobFile } from '@/utils/index'
import EditCertTimeModal from './edit-cert-time-modal.vue'
import CertTemplateSelect from './busi/cert-template-select.vue'
import DownloadButton from '@/components-v2/download-center/download-button.vue'
import { getTimeRange } from '@/utils/formatTime'
export default {
  name: 'LuxuryIdCertIndex',
  components: { EditCertModal, EditCertTimeModal, CertTemplateSelect, DownloadButton },
  data() {
    return {
      loading: true,
      createDownloadFile: Download.downloadidentificationcertsaync,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, certNo: '', time: null, certTemplateId: null },
      multipleSelection: []
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    onValidate() {
      return new Promise((resolve, reject) => {
        if (this.multipleSelection.length === 0) {
          this.$message.error('请选择要下载的证书')
          reject('请勾选要下载的证书')
        } else {
          const identificationCertIds = this.multipleSelection.map(item => item.identificationCertId).join(',')
          resolve({
            query: { identificationCertIds },
            total: this.multipleSelection.length
          })
        }
      })
    },
    downloadidentificationcerts() {
      this.loading = true
      const identificationCertIds = this.multipleSelection.map(item => item.identificationCertId).join(',')
      Cert.downloadidentificationcerts({ identificationCertIds })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
          this.$refs.multipleTable.clearSelection()
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    downloadtemplate(row) {
      this.loading = true
      Cert.downloadidentificationcert({ identificationCertId: row.identificationCertId })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    updateitemtime(row) {
      const { identificationCertId, certNo, certIssuanceTime } = row
      this.$refs.time.update({ identificationCertId, certNo, certIssuanceTime })
    },
    updateitem(row) {
      this.$refs.cert.update({
        identificationCertId: row.identificationCertId,
        certNo: row.certNo,
        certFile: row.certFile.split(',').map(url => ({ url })),
        queryScoreStatus: row.queryScoreStatus
      })
    },
    additem() {
      this.$refs.cert.add(this.userInfo.orgId)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该证书?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deleteidentificationcert', {
          payload: {
            identificationCertId: row.identificationCertId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getQuery(config) {
      const [beginCertIssuanceTime, endCertIssuanceTime, time] = getTimeRange(config.time)
      return { ...config, beginCertIssuanceTime, endCertIssuanceTime, time }
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getidentificationcerts', {
        payload: this.getQuery(this.config),
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              isH5: (i.certFile || '').includes('.html') // /\/yhb\/(index|report|report1)\.html/g.test(i.certFile)
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
